import { render, staticRenderFns } from "./addNewPhone.vue?vue&type=template&id=8c593472&scoped=true&"
import script from "./addNewPhone.vue?vue&type=script&lang=ts&"
export * from "./addNewPhone.vue?vue&type=script&lang=ts&"
import style0 from "./addNewPhone.vue?vue&type=style&index=0&id=8c593472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c593472",
  null
  
)

export default component.exports